<template>
  <div class="home" :class="{ 'wg': !$store.state.isCy }">
    <div class="wrap">
      <a href="https://www.wegame.com.cn/store/2001788" v-if="!$store.state.isCy && $store.state.isPC"
      target="_blank" class="btn btn-bg2 btn_xz">下载游戏</a>
      <div class="kv" id="kv">
        <div class="ld-box"></div>
        <a href="http://tlhj.changyou.com/main.shtml" class="tlhj-logo" title="《新天龙八部》怀旧服—官方网站" target="_blank"></a>
        <div class="login-box">
          <div class="login-before" v-if="!$store.state.userInfo">
            <a href="javascript:;" @click="$store.dispatch('login')">点击登录账号</a>
          </div>
          <div class="login-after" v-if="$store.state.userInfo">
            欢迎您，{{ $store.state.userInfo?.cn }}
            <a class="tl_btn" href="javascript:;" @click="openUserZx()">【个人中心】</a>
            <a href="javascript:;" @click="$store.dispatch('logout')">注销</a>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="home-tab-box" :class="{ 'wg': !$store.state.isCy }">
          <div class="tab tab1" :class="{ 'on': currentTab === 1 }" @click="switchTab(1)"></div>
          <div class="tab tab2" v-if="$store.state.isCy" :class="{ 'on': currentTab === 2 }" @click="switchTab(2)">
          </div>
          <div class="tab tab3" :class="{ 'on': currentTab === 3 }" @click="switchTab(3)"></div>
          <div class="tab tab4" :class="{ 'on': currentTab === 4 }" @click="switchTab(4)"></div>
          <div class="tab tab5" :class="{ 'on': currentTab === 5 }" @click="switchTab(5)"></div>
        </div>
        <div class="tab-con tab1-con" v-show="currentTab === 1">
          <div class="part part3" id="part3">
            <a href="javascript:;" class="xf_icon1" @click="goZd()" v-if="$store.state.isCy"></a>
            <div class="title title3"></div>
            <div class="p3-con-bg">
              <div class="bg_s" v-if="$store.state.isCy">开服时间:2月24日19:00 怀旧五区 常规新服，<br v-if="!$store.state.isPC"/>2月27日19:00开启原始服新服。</div>
              <div class="bg_s" v-else>开服时间：2026年2月24日19:00</div>
              <div class="tip" v-if="$store.state.isCy">
                少侠可选择任一新服进行预约。无论预约哪一组新服，都可以在两个新服中领取预约好礼。少侠可在个人中心处查看礼包领取情况。新服开启后，少侠可至大理(171,123)龚彩云处领取。
              </div>
              <div class="tip" v-else>
                少侠可在个人中心处查看礼包领取情况。新服开启后，少侠可至大理(171,123)龚彩云处领取。
              </div>
            </div>
            <div>
              <!-- 常规服 -->
              <div class="prop-box">
                <div class="item" :class="{ 'acitve': $store.state.userInfo?.status }">
                  <div class="jd jd1"><i></i></div>
                  <div class="box-bg">
                    <img v-if="$store.state.userInfo?.status" class="box1" src="@/assets/image/box1.png" alt="" />
                    <img v-else class="box" src="@/assets/image/box2.png" alt="" />
                    <img class="h-img pc-img" src="@/assets/image/h-prop1.png" alt="" />
                    <img class="h-img h5-img" src="@/assets/image/m/h-prop1.png" alt="" />
                  </div>
                  <div class="num">预约成功</div>
                </div>
                <div class="item" :class="{ 'acitve': !$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 5000 : $store.state.activityConfig?.reservationNum2 >= 5000 }">
                  <div class="jd jd2"><i></i></div>
                  <div class="box-bg">
                    <img v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 5000 : $store.state.activityConfig?.reservationNum2 >= 5000" class="box1"
                      src="@/assets/image/box1.png" alt="" />
                    <img v-else class="box" src="@/assets/image/box2.png" alt="" />
                    <img class="h-img pc-img" src="@/assets/image/h-prop2.png" alt="" />
                    <img class="h-img h5-img" src="@/assets/image/m/h-prop2.png" alt="" />
                  </div>
                  <div class="num">5000人</div>
                </div>
                <div class="item" :class="{ 'acitve': !$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 10000 : $store.state.activityConfig?.reservationNum2 >= 10000 }">
                  <div class="jd jd3"><i></i></div>
                  <div class="box-bg">
                    <img v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 10000 : $store.state.activityConfig?.reservationNum2 >= 10000" class="box1"
                      src="@/assets/image/box1.png" alt="" />
                    <img v-else class="box" src="@/assets/image/box2.png" alt="" />
                    <img class="h-img pc-img" src="@/assets/image/h-prop3.png" alt="" />
                    <img class="h-img h5-img" src="@/assets/image/m/h-prop3.png" alt="" />
                  </div>
                  <div class="num">10000人</div>
                </div>
                <div class="item" :class="{ 'acitve': !$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 15000 : $store.state.activityConfig?.reservationNum2 >= 15000 }">
                  <div class="jd jd4"><i></i></div>
                  <div class="box-bg">
                    <img v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 15000 : $store.state.activityConfig?.reservationNum2 >= 15000" class="box1"
                      src="@/assets/image/box1.png" alt="" />
                    <img v-else class="box" src="@/assets/image/box2.png" alt="" />
                    <img class="h-img pc-img" src="@/assets/image/h-prop4.png" alt="" />
                    <img class="h-img h5-img" src="@/assets/image/m/h-prop4.png" alt="" />
                  </div>
                  <div class="num">15000人</div>
                </div>
                <div class="item" :class="{ 'acitve': !$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 20000 : $store.state.activityConfig?.reservationNum2 >= 20000 }">
                  <div class="jd jd5"><i></i></div>
                  <div class="box-bg">
                    <img class="box1" v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 20000 : $store.state.activityConfig?.reservationNum2 >= 20000"
                      src="@/assets/image/box1.png" alt="" />
                    <img class="box" v-else src="@/assets/image/box2.png" alt="" />
                    <img class="h-img pc-img" src="@/assets/image/h-prop5.png" alt="" />
                    <img class="h-img h5-img" src="@/assets/image/m/h-prop5.png" alt="" />
                  </div>
                  <div class="num">20000人</div>
                </div>
                <div class="speed_icon">
                  <i class="speed speed1" v-if="$store.state.userInfo?.status"></i>
                  <i class="speed speed2" v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 5000 : $store.state.activityConfig?.reservationNum2 >= 5000"></i>
                  <i class="speed speed3" v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 10000 : $store.state.activityConfig?.reservationNum2 >= 10000"></i>
                  <i class="speed speed4" v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 15000 : $store.state.activityConfig?.reservationNum2 >= 15000"></i>
                  <i class="speed speed5" v-if="!$store.state.isOriginalServer?$store.state.activityConfig?.reservationNum1 >= 20000 : $store.state.activityConfig?.reservationNum2 >= 20000"></i>
                </div>
                <!-- speed-box预约后加类名yy 大于20000加类名yy2 -->
                <!-- <div class="speed-box yy" :class="{'yy2': $store.state.activityConfig?.reservationNum1 >= 20000}">
                                <div>
                                    <div class="speed-bar" :style="{
                                        width: yyNum + '%',
                                    }">
                                    </div>
                                </div>
                            </div> -->
              </div>
              <div class="yy-num-bg">已有 <span>
                  <em v-if="!$store.state.isOriginalServer">{{
                    $store.state.activityConfig?.reservationNum1 ? $store.state.activityConfig?.reservationNum1 : '0'
                    }}</em>
                  <em v-else>{{
                    $store.state.activityConfig?.reservationNum2 ? $store.state.activityConfig?.reservationNum2 : '0'
                    }}</em> 名
                </span> 少侠预约

                <em v-if="$store.state.isCy">{{ $store.state.isOriginalServer ? '原始服' : '常规服' }}</em>
                <em v-else>新服</em>
              </div>
            </div>
            <div class="btn-box flex">
              <a href="javascript:;" v-if="$store.state.isCy" :class="{ gray: $store.state.userInfo?.status }"
                class="btn btn-bg1 tl_btn" @click="getYyState()">
                <!-- 立即预约 -->
                {{ $store.state.userInfo?.area == 1 ? '已预约常规服' : $store.state.userInfo?.area == 2 ? '已预约原始服' : $store.state.isOriginalServer ? '立即预约原始服' : '立即预约常规服' }}
              </a>
              <a href="javascript:;" v-else :class="{ gray: $store.state.userInfo?.status }" class="btn btn-bg1 tl_btn"
                @click="getYyState()">
                <!-- 立即预约 -->
                {{ $store.state.userInfo?.status ? '已预约' : '立即预约' }}
              </a>
              <a href="javascript:;" class="btn btn-bg1 tl_btn" v-if="$store.state.isCy"
                @click="$store.state.isOriginalServer = !$store.state.isOriginalServer">切换{{
                  !$store.state.isOriginalServer ? '原始服' : '常规服' }}</a>
            </div>
          </div>
          <div class="part part4">
            <div class="title title4"></div>
            <div class="p4-con-bg">
              <div class="prop-box"></div>
              <div class="btn-box flex">
                <a href="javascript:;" class="btn btn-bg2 tl_btn"
                  :class="{ 'gray': $store.state?.giftRecord.length > 0 && $store.state?.giftRecord[0]?.isGet }"
                  @click="getHgGift()">
                  {{
                    $store.state?.giftRecord.length > 0 && $store.state?.giftRecord[0]?.isGet
                      ? '已领取'
                      : '立即领取'
                  }}
                </a>
                <a href="javascript:TGDialogS('dia10');" class="btn btn-bg2" @click="">领取规则</a>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-con tab2-con" v-if="$store.state.isCy" v-show="currentTab === 2">
          <div class="part part1">
            <div class="title title1"></div>
            <div class="tip">
              <p>少侠可在页面上对账号进行价值鉴定，截止至2026年2月1日，查询账号对应的实名下，全部账号的历史消费，领取对应档位的怀旧专属礼包。</p>
            </div>
            <!-- <div class="dq-bg">
              您当前的消费点数：{{ $store.state.consume ? $store.state.consume?.consumption : 0 }}
            </div> -->
            <div class="xf_img"></div>
            <div class="btn_box flex">
              <a href="javascript:;" class="btn btn-bg3 tl_btn" @click="getCzData()">查询消费</a>
              <a href="javascript:TGDialogS('dia7');" class="btn btn-bg3 tl_btn">活动规则</a>
              <a href="javascript:;" class="btn btn-bg3 tl_btn"
                :class="{ 'gray': $store.state?.giftRecord.length > 0 && $store.state?.giftRecord[6]?.isGet }"
                @click="getXsGift()">
                {{
                  $store.state?.giftRecord.length > 0 && $store.state?.giftRecord[6]?.isGet
                    ? '已领取'
                    : '礼包领取'
                }}
              </a>
            </div>
          </div>
        </div>
        <div class="tab-con tab3-con" v-show="currentTab === 3">
          <div class="part part5">
            <div class="title title5"></div>
            <div class="p5-con-bg">
              <div class="bg_s">
                预充时间：即日起—2月24日16:00
              </div>
              <div class="tip">
                新服预充值点数达指定额度即可获得以下奖励、且预充值点数将在2026年3月25日24:00过期，请及时兑换
              </div>
              <div class="tip" v-if="$store.state.isCy">
                <span>2月24日16:00将在预充值达到5000元档位中抽取一位幸运少侠获得坐骑：紫电(永久)，仅限新服使用</span>
              </div>
              <div class="dq-bg">
                您当前的新服预充值点数：{{ $store.state.recharge?.preRecharge1 ? $store.state.recharge?.preRecharge1 : 0 }}
              </div>
              <div class="img-box">
                <!-- 四个档添加类名on展示已达成标签 -->
                <div>
                  <i class="yc yc1" :class="{ 'on': $store.state.recharge?.preRecharge1 >= 12000 }"></i>
                  <i class="yc yc2" :class="{ 'on': $store.state.recharge?.preRecharge1 >= 30000 }"></i>
                  <i class="yc yc3" :class="{ 'on': $store.state.recharge?.preRecharge1 >= 60000 }"></i>
                  <i class="yc yc4" :class="{ 'on': $store.state.recharge?.preRecharge1 >= 100000 }"></i>
                </div>
                <img class="pc-img" v-if="$store.state.isCy" src="@/assets/image/p5-con-img.png" alt="" />
                <img class="pc-img" v-else src="@/assets/image/p5-con-img2.png" alt="" />
                <img class="h5-img" v-if="$store.state.isCy" src="@/assets/image/m/p5-con-img.png" alt="" />
                <img class="h5-img" v-else src="@/assets/image/m/p5-con-img2.png" alt="" />
              </div>
              <div class="btn_box flex">
                <a class="btn btn-bg1 tl_btn" @click="goCz()" href="javascript:;">
                  我要充值
                </a>
                <!-- <a class="btn btn-bg1 tl_btn p5_btn-bg1"
                  @click="$store.state.isOriginalServerCz = !$store.state.isOriginalServerCz" href=" javascript:;">
                  切换{{ $store.state.isOriginalServerCz ? '常规服' : '原始服' }}预充值
                </a> -->
              </div>
            </div>
          </div>
          <div class="part part6">
            <div class="title title6"></div>
            <div class="rules" v-if="$store.state.isCy">
              <p>1、需先在页面预充值至指定额度，新服开启后，预充的道具奖励请少侠至大理（171，123）龚彩云处领取。</p>
              <p>2、首月排队快速通道用户进入新服时可享受优先排队权利，若同一时间进入人数过多使排队人数达到上限，还请耐心等待或重新尝试排队。本次绿色通道失效时间为：2026年3月25日24:00。</p>
              <p>3、预充值5000元，则4档奖励均可领取。且常规新服和原始新服将同步发放预充值奖励，并共享快速排队通道。</p>
              <p>4、少侠预充值后，若未能查询到对应的点数，请稍等2分钟后试试吧。</p>
              <p>5、预充值点数在常规新服【白马春衫】和原始新服【追风踏雪】均可兑换，且将在2026年3月25日24:00失效。</p>
            </div>
            <div class="rules" v-else>
              <p>1、需先在页面预充值至指定额度，新服开启后，预充的道具奖励请少侠至大理（171，123）龚彩云处领取。</p>
              <p>2、首月排队快速通道用户进入新服时可享受优先排队权利，若同一时间进入人数过多使排队人数达到上限，还请耐心等待或重新尝试排队。<br>
                本次绿色通道失效时间为：2026年3月25日24:00。</p>
              <p>3、少侠预充值后，若未能查询到对应的点数，请稍等2分钟后试试吧。</p>
              
            </div>
          </div>
        </div>
        <div class="tab-con tab4-con" v-show="currentTab === 4">
          <div class="part part2">
            <div class="title title2"></div>
            <div class="bg_s">
              <p> <span>抽奖时间:即日起-2026年3月25日13:59</span></p>
            </div>
            <div class="cj_bg" :class="{ 'wg': !$store.state.isCy }">
              <div class="cj_prop_swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img src="@/assets/image/cj_prop1.png" alt="">
                  </div>
                  <div class="swiper-slide">
                    <img src="@/assets/image/cj_prop2.png" alt="">
                  </div>
                  <div class="swiper-slide">
                    <img src="@/assets/image/cj_prop3.png" alt="">
                  </div>
                </div>
                <div class="cj_next"></div>
                <div class="cj_prev"></div>
              </div>
              <div class="cj_box">
                <img v-if="$store.state.isCy" src="@/assets/image/cj_img.png" alt="">
                <img v-else src="@/assets/image/cj_img_wg.png" alt="">
                <a class="btn cj_btn tl_btn" href="javascript:;" @click="drawLottery()">

                  <span>我的抽奖券：{{ lotteryChances }}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="part part7">
            <div class="title title7"></div>
            <div class="p7-con-bg">
              <div class="task_box">
                <div class="task_item" v-for="(item, index) in taskList">
                  <div class="task_con">{{ item.name }}</div>
                  <div class="btn_box flex">
                    <a class="btn btn-bg1 tl_btn" href="javascript:;" @click="taskSubmit(item)"
                      :class="{ 'gray': item.status == 2 }">
                      <span>
                        <em v-if="item.status == 0 && index == 0">点击预约</em>
                        <em v-else-if="item.status == 0">未达成</em>
                        <em v-else-if="item.status == 1">点击领取</em>
                        <em v-else-if="item.status == 2">已完成</em>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <a href="javascript:TGDialogS('dia8');" class="btn btn-bg1 tl_btn">活动规则</a>
            </div>
          </div>
        </div>
        <div class="tab-con tab5-con" v-show="currentTab === 5">
          <div class="part part8">
            <div class="title title8"></div>
            <div class="p8-con-bg">
            </div>
          </div>
          <div class="part part9">
            <div class="title title9"></div>
            <p class="tip">
              全新地宫:开服首月，等级>10级的玩家可通过剑阁(281,81)龙贾处前往秦宫秘境一、二、三层<br>
              每日08:00至23:59。注意:秦宫秘境一、三层均为允许宣战、不加杀气的场景，少侠请多加小心。
            </p>
            <div class="p9-con-bg">
            </div>
          </div>
        </div>

        <!-- <div class="swiper-box2">
          <div class="swiper swiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot1.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot2.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot3.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot4.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot5.png" alt="" />
                </div>
              </div>
              <div class="swiper-slide">
                <div>
                  <img src="@/assets/image/foot6.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination1"></div>
        </div> -->
      </div>
    </div>
    <!-- 预约手机号：验证码 -->
    <div class="dialog " id="dia3">
      <div class="dia dia1 diaTipYy">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit-yy"></div>
        <div class="phone-box">
          <div class="item">
            <div class="text">预约手机号：</div>
            <input type="text" maxlength="11" placeholder="请输入手机号" v-model="phoneNumber" />
          </div>
          <p class="dia-tips" v-show="isPhone">请输入正确的手机号</p>
          <div class="item">
            <div class="text">验证码：</div>
            <div class="inp-box">
              <input type="text" maxlength="6" placeholder="请输入验证码" v-model="verificationCode" />
              <a href="javascript:;" class="get-code" :class="{ disabled: isCounting }" @click="handleSendCode">
                {{ isCounting ? `${countdown}s` : '发送验证码' }}
              </a>
            </div>
          </div>
          <p class="dia-tips" v-show="isCode">请输入正确的验证码</p>
        </div>
        <a href="javascript:;" class="btn btn-bg2 dia-btn" @click="goToYy()">
          立即预约<span v-if="$store.state.isCy">{{ $store.state.isOriginalServer ? '原始服' : '常规服' }}</span>
        </a>
      </div>
    </div>
    <!-- 填写地址 -->
    <div class="dialog " id="dia9">
      <div class="dia dia1 diaTipYy">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <!-- <div class="dia-tit dia-tit-yy"></div> -->
        <div class="phone-box">
          <div class="item">
            <div class="text">收件人名称：</div>
            <input type="text" v-model="contact" placeholder="请输入收件人名称" />
          </div>
          <div class="item">
            <div class="text">收件手机号：</div>
            <input type="text" maxlength="11" v-model="contactPhone" placeholder="请输入手机号" />
          </div>
          <div class="item">
            <div class="text">收件地址：</div>
            <textarea type="text" v-model="contactAddress" placeholder="请输入地址" />
          </div>

        </div>
        <a href="javascript:;" class="btn btn-bg2 dia-btn" @click="setAddress()">
          确定
        </a>
      </div>
    </div>
    <!-- 个人中心 -->
    <div class="dialog" id="dia6">
      <div class="dia dia2">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit3"></div>
        <div class="dia_tip">奖励领取情况</div>
        <div class="cdk_box">
          <div class="l">新手卡：{{
            $store.state.userInfo?.cdkey
              ? $store.state.userInfo?.cdkey
              : '--'
          }}</div>
          <a href="javascript:;" @click="copyCdk($store.state.userInfo?.cdkey)" class="btn btn_copy btn-bg2">一键复制</a>
        </div>
        <ul>
          <li>
            <div>奖励</div>
            <div>领奖状态</div>
          </li>
          <li v-for="item in $store.state?.giftRecord">
            <div>{{ item.giftName }}</div>
            <div><span v-if="item.isGet !== 2">{{ item.isGet == 1 ? '✔' : '✖' }}</span>
              <span v-else><a href="javascript:;" @click="openAddressDialog()">填写地址</a></span>
            </div>
          </li>
          <li v-if="!$store.state.giftRecord?.length">
            <div style="width: 100%; text-align: center;background: none;">暂无礼包记录</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 前往实名认证 -->
    <div class="dialog" id="diaRealName">
      <div class="dia dia1 diaTipcg">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tip">
          您的账号还未绑定实名信息
        </div>
        <a href="https://member.changyou.com/info_framework/parent_frame_aq_new.jsp?name=smFill" title="前往绑定"
          class="btn btn-bg2 dia-btn" target="_blank">前往绑定</a>
      </div>
    </div>

    <!-- 恭喜获得 -->
    <div class="dialog" id="dia11">
      <div class="dia dia1">
        <a href="javascript:closeDialog();" class="dia-close"></a>
        <div class="dia-tit dia-tit1"></div>
        <div class="dia-tip" id="">
          恭喜您获得{{ currentDrawPrize?.gift.giftName }} 
          <em v-if="currentDrawPrize?.gift.type == 1"><br> 请在3月25日23:59之前填写收件信息</em>
        </div>
        <div class="btn_box flex">
          <a href="javascript:closeDialog();" class="btn btn-bg2 dia-btn">确定</a>
          <a href="javascript:;" v-if="currentDrawPrize?.gift.type == 1" class="btn btn-bg2 dia-btn"
            @click="openAddressDialog()">填写收件地址</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { authGet, userGet, authPost, userPost } from "@/request/index.js";
export default {
  name: "HomeView",
  data() {
    return {
      currentTab: 1, // 当前选中的tab，默认选中第一个
      LvTab: 1, // 冲级榜单当前选中的tab，默认选中第一个
      // 第二页数据
      isDia1: false,
      isDiaSb: false,
      isDiaCg: false,
      isDiaYy: false,
      isDiaWbd: false,
      isPC: !/mobile|android|iphone|ipad|phone/i.test(
        navigator.userAgent.toLowerCase()
      ),
      phoneNumber: "", //手机号
      verificationCode: "", // 验证码
      countdown: 30,
      isCounting: false, //
      timer: null,
      isPhone: false, // 手机号是否正确
      isCode: false, // 验证码是否填写
      yyNum: Math.min((this.$store.state.activityConfig?.reservationNum1 / 20000) * 100, 100), // 预约人数
      isSubmitting: false, // 是否正在提交预约
      isRequesting: false, // 是否正在领取老友礼

      // 任务列表
      taskList: [
        {
          "type": 1,
          "name": "预约新服",
          "status": 0
        },
        {
          "type": 2,
          "name": "等级达到80级",
          "status": 0
        },
        {
          "type": 3,
          "name": "领取400档位周活跃值奖励",
          "status": 0
        },
        {
          "type": 4,
          "name": "领取800档位周活跃值奖励",
          "status": 0
        },
        {
          "type": 5,
          "name": "领取1200档位周活跃值奖励",
          "status": 0
        }

      ],
      // 查询消费节流
      getCzDataDebounced: null,
      // 抽奖节流
      drawLotteryDebounced: null,
      // 当前抽中的奖品
      currentDrawPrize: null,


      contact: "", // 收件人名称
      contactPhone: "", // 收件人手机号
      contactAddress: "", // 收件人地址

      lotteryChances: 0, // 抽奖次数
      //
    };
  },
  watch: {
    // 监听store中的预约人数变化，更新缓存和yyNum
    '$store.state.activityConfig.reservationNum1'(newVal) {
      if (newVal !== undefined && newVal !== null) {
        this.yyNum = Math.min((newVal / 20000) * 100, 100);
        localStorage.setItem('cachedreservationNum1', newVal.toString());
      }
    }
  },
  methods: {
    // 紫电跳转
    goZd(){
      if(this.$store.state.activityConfig?.lotteryDrawUrl?.trim()){
        window.location.href = this.$store.state.activityConfig?.lotteryDrawUrl;
      }else{
        return false;
      }

    },
    // 切换tab
    switchTab(tabIndex) {
      this.currentTab = tabIndex;
    },
    // 判断账户预约状态
    async getYyState() {
      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      if (!this.$store.state.userInfo) {
        this.$store.dispatch("login");
        return;
      }
      if (this.$store.state.isReservationStarted) {
        document.getElementById("diaTipText").innerHTML = "预约阶段未开始";
        TGDialogS("diaTip");
        return false;
      } else if (this.$store.state.isReservationEnded) {
        document.getElementById("diaTipText").innerHTML = "预约阶段已结束";
        TGDialogS("diaTip");
        return false;
      }

      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.$store.commit("CHECK_USER_BANNED");
      const res = await userPost("api/home/checkAuthPhone", {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, "查询预约");

      setTimeout(() => {
        this.isSubmitting = false;
      }, 1000); // 1秒后允许再次点击，避免快速重复提交
      if (res.code == 0) {
        TGDialogS("dia3");
      } else if (res.code == 1003) {
        // 未绑定认证手机号
        TGDialogS("dia1");
        //
      } else if (res.code == 1004) {
        //已经预约过了
        TGDialogS("diaTip");
        document.getElementById("diaTipText").innerHTML = "您已预约过了";
      }
    },
    // 去预约
    async goToYy() {
      try {
        if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
          this.isPhone = true;
          return;
        }
        if (!this.verificationCode) {
          this.isCode = true;
          return;
        }
        this.isCode = false;
        const urlParams = new URLSearchParams(window.location.search);
        const inviteCode = urlParams.get("inviteCode");
        console.log({
          uin: this.$store.state.userInfo?.uin,
          phone: this.phoneNumber,
          code: this.verificationCode,
          inviteCode: inviteCode ? inviteCode : "",
        });
        const res = await userPost("api/sub/subAct", {
          uin: this.$store.state.userInfo?.uin,
          phone: this.phoneNumber,
          code: this.verificationCode,
          inviteCode: inviteCode ? inviteCode : "",
          area: this.$store.state.isOriginalServer ? 2 : 1,
        });
        console.log(res, "预约");
        if (res.code == 0) {
          this.$store.commit(
            "UPDATE_RESERVATION_NUM",
            this.$store.state.activityConfig?.reservationNum1 + 1
          );
          this.$store.commit("UPDATE_AREA", this.$store.state.isOriginalServer ? 2 : 1);
          // this.getSubNum();
          this.$store.dispatch("fetchGiftRecord");
          this.$store.commit("UPDATE_CDKEY", res.data.cdkey);
          this.$store.commit("UPDATE_STATUS", 1);
          this.$store.commit("UPDATE_GIFT", {
            index: 1,
            value: 1,
          });
          setTimeout(() => {
            localStorage.setItem(
              "userInfo"+this.$store.state.isCy,
              JSON.stringify(this.$store.state.userInfo)
            );
            localStorage.setItem("cdkey", res.data.cdkey);
          }, 0);

          TGDialogS("dia4");
        } else {
          document.getElementById("diaTipText").innerHTML = res.msg;
          TGDialogS("diaTip");
        }
      } finally {
      }
    },
    //获取验证码
    async handleSendCode() {
      // 简单手机号验证（可根据需求调整）
      if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
        this.isPhone = true;
        return;
      }
      this.isPhone = false;
      // 开始倒计时
      this.isCounting = true;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isCounting = false;
          this.countdown = 30; // 重置倒计时
        }
      }, 1000);

      // TODO: 实际项目中这里会调用发送验证码的API
      console.log("模拟发送验证码到:", this.phoneNumber);
      const res = await userPost("api/sub/sendMobileCode", {
        phone: this.phoneNumber,
        area: this.$store.state.isOriginalServer ? 2 : 1,
      });
      console.log(res, "验证码");
      if (res.code == 0) {
        console.log("验证码发送成功");
        this.verificationCode = res.data;
      }
    },
    // 领取回归礼
    async getHgGift() {

      try {
        const isActivityTimeValid = await this.$store.dispatch(
          "checkActivityTime"
        );
        if (!isActivityTimeValid) {
          return;
        }
        if (!this.$store.state.userInfo) {
          this.$store.dispatch("login");
          return;
        }
        console.log(this.$store.state.oldFriend);
        if (!this.$store.state.oldFriend?.isly) {
          document.getElementById("diaTipText").innerHTML = "您不是回归好友";
          TGDialogS("diaTip");
          return;
        }

        if (this.isRequesting) return;
        this.isRequesting = true;
        const fromToken = await this.$store.dispatch("getFromToken");
        const res = await userPost("api/users/receiveGift", {
          uin: this.$store.state.userInfo?.uin,
          giftid: 1,
          from_token: fromToken,
        });
        console.log(res, "领取回归礼");
        if (res.code == 0) {
          this.$store.commit("UPDATE_GIFT", {
            index: 0,
            value: 1,
          });
          this.$store.dispatch("fetchGiftRecord");
          // localStorage.setItem(
          //   'giftRecord',
          //   JSON.stringify(this.$store.state.giftRecord)
          // );
          TGDialogS("dia5");
        } else {

          document.getElementById("diaTipText").innerHTML = res.msg;
          TGDialogS("diaTip");
        }
      } finally {
        setTimeout(() => {
          this.isRequesting = false;
        }, 2000);
      }
    },
    // 打开个人中心
    async openUserZx() {
      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      this.$store.commit("SET_SHOW_ISDIA3", true);
    },
    // 查询消费
    async getCzData() {
      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      if (!this.$store.state.userInfo) {
        this.$store.dispatch("login");
        return;
      }
      if (this.getCzDataDebounced) {
        return;
      }
      try {
        this.getCzDataDebounced = true;
        const res = await userPost("/api/home/roleQuery", {
          uin: this.$store.state.userInfo?.uin,
        });
        console.log(res, "查询消费");
        if (res.code == 0) {
          this.$store.commit("UPDATE_CONSUME", res.data);
          TGDialogS('diaTip');
          document.getElementById("diaTipText").innerHTML = '您当前的消费元宝数为：' + res.data.consumption;
        }
        if (res.code == 1007) {
          TGDialogS('diaRealName');
          return;
        }
      } finally {
        setTimeout(() => {
          this.getCzDataDebounced = false;
        }, 1000);
      }
    },
    // 领取消费礼
    async getXsGift() {
      try {
        const isActivityTimeValid = await this.$store.dispatch(
          "checkActivityTime"
        );
        if (!isActivityTimeValid) {
          return;
        }
        if (!this.$store.state.userInfo) {
          this.$store.dispatch("login");
          return;
        }
        if (this.$store.state.consume == null) {
          document.getElementById("diaTipText").innerHTML = "请先查询消费点数";
          TGDialogS("diaTip");
          return;
        }

        if (this.isRequesting) return;
        this.isRequesting = true;
        const fromToken = await this.$store.dispatch("getFromToken");
        const res = await userPost("api/users/receiveGift", {
          uin: this.$store.state.userInfo?.uin,
          giftid: 12,
          from_token: fromToken,
        });
        console.log(res, "领取消费礼");
        if (res.code == 0) {
          this.$store.commit("UPDATE_GIFT", {
            index: 6,
            value: 1,
          });
          this.$store.dispatch("fetchGiftRecord");
          TGDialogS("dia5");
        } else {

          document.getElementById("diaTipText").innerHTML = res.msg;
          TGDialogS("diaTip");
        }
      } finally {
        setTimeout(() => {
          this.isRequesting = false;
        }, 2000);
      }
    },

    // 复制cdk
    copyCdk(cdk) {
      if (!cdk) {
        this.$toast("暂无新手卡，请预约");
        return;
      }
      this.$copyText(cdk);
      document.getElementById("diaTipText").innerHTML = "复制成功";
      TGDialogS("diaTip");
    },

    async goCz() {
      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      if (!this.$store.state.userInfo) {
        this.$store.dispatch("login");
        return;
      }
      const res = await userPost("api/users/recharge", {
        uin: this.$store.state.userInfo?.uin,
        area: this.$store.state.isOriginalServerCz ? 2 : 1,
        port: this.$store.state.isPC ? "p" : "m",
      });
      console.log(res, "预充值");
      if (res.code == 0) {
        if (!this.$store.state.isPC) {
          window.location.href = res.data.getUrl;
        } else {
          window.open(res.data.getUrl, "_blank");
        }
      } else if (res.code == 1104) {
        document.getElementById("diaTipText").innerHTML =
          "预充值活动尚未开始！";
        TGDialogS("diaTip");
      } else if (res.code == 1105) {
        document.getElementById("diaTipText").innerHTML =
          "预充活动已结束，新服开启后可进游戏内领奖！";
        TGDialogS("diaTip");
      } else {
        document.getElementById("diaTipText").innerHTML = res.msg;
        TGDialogS("diaTip");
      }
    },
    // 获取任务列表
    async getTaskList() {

      const res = await userPost("/api/lottery/taskList", {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, "任务列表");
      if (res.code == 0) {
        this.taskList = res.data.list;
      }
    },
    // 完成任务
    async taskSubmit(item) {
      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      if (!this.$store.state.userInfo) {
        this.$store.dispatch("login");
        return;
      }
      if (item.name == '预约新服' && item.status == 0) {
        // 切换到第一个预约tab并滚动到part3
        this.currentTab = 1;
        setTimeout(() => {
          document.getElementById('part3').scrollIntoView({ behavior: 'smooth' });
        }, 100);
        return;
      }
      const fromToken = await this.$store.dispatch("getFromToken");
      const res = await userPost("/api/lottery/taskSubmit", {
        uin: this.$store.state.userInfo?.uin,
        type: item.type,
        from_token: fromToken,
      });
      console.log(res, "完成任务");
      if (res.code == 0) {
        this.getTaskList();
        this.updateLotteryChances();
        document.getElementById("diaTipText").innerHTML = res.msg;
        TGDialogS("diaTip");
      } else {
        document.getElementById("diaTipText").innerHTML = res.msg;
        TGDialogS("diaTip");
      }
    },
    // 抽奖
    async drawLottery() {

      const isActivityTimeValid = await this.$store.dispatch(
        "checkActivityTime"
      );
      if (!isActivityTimeValid) {
        return;
      }
      if (!this.$store.state.userInfo) {
        this.$store.dispatch("login");
        return;
      }
      if (this.drawLotteryDebounced) {
        return;
      }
      // 如果抽奖券数量不足
      if (this.lotteryChances <= 0) {
        document.getElementById("diaTipText").innerHTML = "抽奖券数量不足";
        TGDialogS("diaTip");
        return;
      }
      // 如果未预约
      if (!this.$store.state.userInfo?.status) {
        document.getElementById("diaTipText").innerHTML = "请先预约新服";
        TGDialogS("diaTip");
        return;
      }
      try {
        this.drawLotteryDebounced = true;
        const fromToken = await this.$store.dispatch("getFromToken");
        const res = await userPost("/api/lottery/runLottery", {
          uin: this.$store.state.userInfo?.uin,
          from_token: fromToken,
        });
        console.log(res, "抽奖");
        if (res.code == 0) {
          this.updateLotteryChances();
          // document.getElementById("diaTipText").innerHTML = res.msg;
          TGDialogS("dia11");
          this.currentDrawPrize = res.data;
          this.$store.dispatch("fetchGiftRecord");
        } else {
          document.getElementById("diaTipText").innerHTML = res.msg;
          TGDialogS("diaTip");
        }
      } finally {
        setTimeout(() => {
          this.drawLotteryDebounced = false;
        }, 1000);
      }
    },
    // 打开收货弹窗
    openAddressDialog() {
      TGDialogS("dia9");
    },
    // 设置收货地址
    async setAddress() {
      const fromToken = await this.$store.dispatch("getFromToken");
      const res = await userPost("/api/Lottery/setAddress", {
        uin: this.$store.state.userInfo?.uin,
        address: this.address,
        // id: item?.id,
        phone: this.contactPhone,
        contact: this.contact,
        address: this.contactAddress,
        from_token: fromToken,
      });
      console.log(res, "设置收货地址");
      if (res.code == 0) {
        document.getElementById("diaTipText").innerHTML = res.msg;
        TGDialogS("diaTip");
        this.$store.dispatch("fetchGiftRecord");
      } else {
        document.getElementById("diaTipText").innerHTML = res.msg;
        TGDialogS("diaTip");
      }
    },
    // 更新抽奖次数
    async updateLotteryChances() {
      const res = await userPost("/api/Lottery/queryCount", {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, "更新抽奖次数");
      if (res.code == 0) {
        this.lotteryChances = res.data.lotteryChances;
      }
    },

    // 获取用户基础信息
    async getUserBaseInfo() {
      const res = await userPost("api/users/info", {
        uin: this.$store.state.userInfo?.uin,
      });
      console.log(res, "获取用户基础信息");
      if (res.code == 0) {
        this.$store.commit("UPDATE_AREA", res.data.area);
      }
    },
  },
  watch: {
    '$store.state.userInfo': {
      handler(newVal) {
        if (newVal) {
          this.getTaskList();
          this.updateLotteryChances();
          this.getUserBaseInfo();
        }
      },
    },
  },
  mounted() {

    if (this.$store.state.userInfo) {
      this.getTaskList();
      this.updateLotteryChances();
      this.getUserBaseInfo();
    }
    console.log(this.$store.state.isCy);
    // this.getTaskList();
  },
};
</script>
